import React from 'react';
import Word2Img from '../../../assets/word.png';
import { MenuItem } from "@mui/material";
import { saveAs } from 'file-saver';

const WordDownloadButton: React.FC<{ content: any }> = ({ content }) => {

    const downloadAsWord = (content: string, filename: string) => {
        // Apply content transformations
        const formattedContent = content
        .replace(/\n/g, '<br>') // Convert newlines to line breaks
        .replace(/\*{2}([^\*]+)\*{2}/g, '<h2>$1</h2>') // Convert 2 asterisks to h2 tags
        .replace(/\*([^\*]+)\*/g, '<b>$1</b>') // Bold text within single asterisks
        .replace(/_([^_]+)_/g, '<i>$1</i>') // Italicize text within underscores
        .replace(/#+([^#]+)/g, '<h3>$1</h3>') // Level 3 heading (#)
        .replace(/([0-9]+\. )(.*?)(?=\n)/g, '<li>$1 $2</li>'); // Numbered list item
       
        const formattedHtml = `
            <html>
            <head>
                <style>
                    /* Define your CSS styles here */
                    body {
                        font-family: Arial, sans-serif;
                        font-size: 14px;
                        color: #333;
                    }
                    h2 {
                        font-size: 20px;
                        color: #000;
                        margin-bottom: 10px;
                    }
                    ul {
                        list-style-type: disc;
                        margin-left: 20px;
                    }
                </style>
            </head>
            <body>
                ${formattedContent}
            </body>
            </html>
        `;
    
        // Convert the HTML content to a Word document
        const blob = new Blob([formattedHtml], { type: 'application/msword' });
        saveAs(blob, filename);
    };
    

    const handleDownload = () => {
        downloadAsWord(content, 'document.doc');
    };

    const iconStyle = {
        width: '20px',
        height: '20px',
        marginRight: '10px',
        fontSize: '14px'
    };

    return (
        <MenuItem onClick={handleDownload} className="msMenuItem">
            <i className="msIcons">
            <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 384 512" height="20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.4-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"></path></svg>
            </i>   
            {/* <img src={Word2Img} alt="Word" className="msIcons" /> */}
           <span className='msIcons'>Word</span>
        </MenuItem>
    );
};

export default WordDownloadButton;
